import { AsyncPipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { BytesizeIconPipe } from '@portal/pipe';
import { MegaMenuItemComponent } from './mega-menu-item';
import { MegaMenuItem } from './mega-menu-item/mega-menu-item.interface';
import { MegaMenuMobileComponent } from './mega-menu-mobile';
import { BANKING_WITH_US, CIMB_PULSE, DIGITAL_SERVICES, HELP_AND_SUPPORT, PROMOTIONS, QUICK_LINK } from './mega-menu.constant';
import { MegaMenuService } from './mega-menu.service';

@Component({
  selector: 'portal-ui-mega-menu',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    NgForOf,
    AsyncPipe,
    MatStepperModule,
    MatIconModule,
    BytesizeIconPipe,
    MegaMenuMobileComponent,
    MegaMenuItemComponent,
  ],
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MegaMenuComponent {
  @ViewChild('megaMenuMobileStepper') private _megaMenuMobileStepper?: MatStepper;

  private readonly cimbPulse: MegaMenuItem[] = CIMB_PULSE;
  private readonly bankingWithUs: MegaMenuItem[] = BANKING_WITH_US;
  private readonly digitalServices: MegaMenuItem[] = DIGITAL_SERVICES;
  private readonly promotions: MegaMenuItem[] = PROMOTIONS;
  private readonly helpAndSupport: MegaMenuItem[] = HELP_AND_SUPPORT;
  private readonly quickLink: MegaMenuItem[] = QUICK_LINK;

  protected readonly hideStepper = inject(MegaMenuService).resetState$;
  protected readonly megaMenu = [
    {
      title: 'CIMB Pulse',
      icon: 'opportunities',
      menu: this.cimbPulse,
    },
    {
      title: 'Banking With Us',
      icon: 'current_balance',
      menu: this.bankingWithUs,
    },
    {
      title: 'Digital Services',
      icon: 'trading',
      menu: this.digitalServices,
    },
    {
      title: 'Promotions',
      icon: 'promotion',
      menu: this.promotions,
    },
    {
      title: 'Help & Support',
      icon: 'help_support',
      menu: this.helpAndSupport,
    },
    {
      title: 'Quicklinks',
      icon: 'quick_link',
      menu: this.quickLink,
    },
  ] as const;

  protected changeMegaMenuMobileStep(step: number): void {
    if (this._megaMenuMobileStepper) {
      this._megaMenuMobileStepper.selectedIndex = step;
      this.hideStepper.next(false);
    }
  }

  protected resetMegaMenuMobileStep(): void {
    this.hideStepper.next(true);
  }
}
